module.exports = __webpack_public_path__ + "img/assist_code_active.796bb533.jpg";